module.exports = __webpack_public_path__ + "img/0910b_2.f1dd6708.jpg";